import { MODELS, useModel } from "../../api";
import Banner from "../../design-system/components/Banner/Banner.jsx";
import Button from "../../design-system/components/Button/Button.jsx";
import { demoCallToAction } from "./demoCallToAction";

/**
 * The banner across every demo page: names the demo and invites the visitor
 * out of it, into logging in or creating their own Lernreise.
 */
function DemoBanner() {
  const me = useModel(MODELS.ME);
  const action = demoCallToAction(me);

  return (
    <Banner
      title="✦ Demo ✦"
      message={action?.banner}
      actionButton={
        action && (
          <Button width="fit" variant="quaternary" to={action.to}>
            {action.label}
          </Button>
        )
      }
      closeButton={false}
    />
  );
}

export default DemoBanner;
